module.exports = __webpack_public_path__ + "static/media/fedpa-logo.a720dc17.svg";